
export const olivianCategories = [
  "All",
  "Living Spaces",
  "Bedrooms",
  "Bathrooms",
  "Kitchen",
  "Outdoor",
  "Laundry",
  "Extras"
];

export const olivianImages = [
  {
    url: "https://static.readdy.ai/image/7f067113b3811c24b7d00967f8a8e498/a6c35216731ae2a131861d1ed8662112.jpeg",
    title: "Living Room",
    category: "Living Spaces"
  },
  {
    url: "https://static.readdy.ai/image/7f067113b3811c24b7d00967f8a8e498/3deaaeb722ab21c56e8e92086a8504d8.jpeg",
    title: "Guest Book",
    category: "Living Spaces"
  },
  {
    url: "https://static.readdy.ai/image/7f067113b3811c24b7d00967f8a8e498/43c48f1cba5e71738508ee772dccc6dc.jpeg",
    title: "Living Room 3",
    category: "Living Spaces"
  },
  {
    url: "https://static.readdy.ai/image/7f067113b3811c24b7d00967f8a8e498/c1df46d202ce1bf769fe2f961f05cb1a.jpeg",
    title: "Living Room 5",
    category: "Living Spaces"
  },
  {
    url: "https://static.readdy.ai/image/7f067113b3811c24b7d00967f8a8e498/804947f994740fb5d3d3ab55867f0a01.jpeg",
    title: "Dining Room Table",
    category: "Living Spaces"
  },
  {
    url: "https://static.readdy.ai/image/7f067113b3811c24b7d00967f8a8e498/9582cd69ecf29622f26615f950571d3e.jpeg",
    title: "Master Bedroom King Bed",
    category: "Bedrooms"
  },
  {
    url: "https://static.readdy.ai/image/7f067113b3811c24b7d00967f8a8e498/98879fd6e47242789655c397286f20fc.jpeg",
    title: "Master Bedroom 3",
    category: "Bedrooms"
  },
  {
    url: "https://static.readdy.ai/image/7f067113b3811c24b7d00967f8a8e498/32fc7b4fd92c59052646738bc1a09335.jpeg",
    title: "Guest Room 2",
    category: "Bedrooms"
  },
  {
    url: "https://static.readdy.ai/image/7f067113b3811c24b7d00967f8a8e498/86597d383cefba772e6bf90624a62a6d.jpeg",
    title: "Bathroom Vanity",
    category: "Bathrooms"
  },
  {
    url: "https://static.readdy.ai/image/7f067113b3811c24b7d00967f8a8e498/7a5a3ace22ecba7c94b488e1fc38b51a.jpeg",
    title: "Bathroom 3",
    category: "Bathrooms"
  },
  {
    url: "https://static.readdy.ai/image/7f067113b3811c24b7d00967f8a8e498/cf56fbcde746e3ae72f5d3a45911edfa.jpeg",
    title: "Modern Kitchen",
    category: "Kitchen"
  },
  {
    url: "https://static.readdy.ai/image/7f067113b3811c24b7d00967f8a8e498/830ea61734c21599cda65b440aff0e6e.jpeg",
    title: "Kitchen 2",
    category: "Kitchen"
  },
  {
    url: "https://static.readdy.ai/image/7f067113b3811c24b7d00967f8a8e498/e231416a5d204fe3d7e0cd7b67509c71.jpeg",
    title: "Front Porch Seating",
    category: "Outdoor"
  },
  {
    url: "https://static.readdy.ai/image/7f067113b3811c24b7d00967f8a8e498/c3b61fb2a9246a6d4e614f4b7a4f1634.jpeg",
    title: "Outdoor Deck Lounge",
    category: "Outdoor"
  },
  {
    url: "https://static.readdy.ai/image/7f067113b3811c24b7d00967f8a8e498/88350a04bfeed86f2269d9e89dafd8aa.jpeg",
    title: "Outdoor 4",
    category: "Outdoor"
  },
  {
    url: "https://static.readdy.ai/image/7f067113b3811c24b7d00967f8a8e498/e00737f40287c2b2fb82f4c24e5c84d1.jpeg",
    title: "Outdoor 5",
    category: "Outdoor"
  },
  {
    url: "https://static.readdy.ai/image/7f067113b3811c24b7d00967f8a8e498/d427549cc9e275ad762a6f567a7374ec.jpeg",
    title: "Smart Lock",
    category: "Extras"
  },
  {
    url: "https://static.readdy.ai/image/7f067113b3811c24b7d00967f8a8e498/2cf2993f7e8bd9d69cb833f696ac43ce.jpeg",
    title: "Smart Thermostat",
    category: "Extras"
  },
  {
    url: "https://static.readdy.ai/image/7f067113b3811c24b7d00967f8a8e498/5935bc7d61c9c167db3f62bb3ce806be.jpeg",
    title: "Laundry Room",
    category: "Laundry"
  }
];
